import { AnalyticsTracker } from '@backstage/core-plugin-api';

export class AnalyticsURLParamUtils {
  private static lastUsedFilters: URLSearchParams = new URLSearchParams();
  private static analytics: AnalyticsTracker | undefined;

  public static setAnalytics(analyticsTracker: AnalyticsTracker) {
    this.analytics = analyticsTracker;
  }

  public static saveQueryParamsToAnalytics(queryParams: URLSearchParams): void {
    const queryString = queryParams.toString();
    if (this.lastUsedFilters.toString() !== queryString) {
      this.triggerGAEventForSearchParams(this.lastUsedFilters, queryParams);
      this.lastUsedFilters = queryParams;
    }
  }

  private static paramsToMap(
    params: URLSearchParams,
  ): Record<string, string[]> {
    const map: Record<string, string[]> = {};
    params.forEach((value, key) => {
      if (!map[key]) {
        map[key] = [];
      }
      map[key].push(value);
    });
    return map;
  }

  private static triggerGAEventForSearchParams(
    oldParams: URLSearchParams,
    newParams: URLSearchParams,
  ): void {
    const onlyNewParams = this.getNewQueryParams(oldParams, newParams);
    for (const [key, value] of onlyNewParams.entries()) {
      if (this.analytics) {
        this.analytics.captureEvent('filter', 'catalog_filter', {
          attributes: {
            key,
            value,
          },
        });
      } else {
        window.gtag('event', 'catalog_filter', {
          key,
          value,
        });
      }
    }
  }

  private static getNewQueryParams(
    old: URLSearchParams,
    newParams: URLSearchParams,
  ): URLSearchParams {
    const newAndChangedParams = new URLSearchParams();

    const oldMap = this.paramsToMap(old);
    const newMap = this.paramsToMap(newParams);

    for (const [key, newValues] of Object.entries(newMap)) {
      const oldValues = oldMap[key] || [];
      newValues
        .filter(newValue => !oldValues.includes(newValue))
        .forEach(newValue => newAndChangedParams.append(key, newValue));
    }

    return newAndChangedParams;
  }
}
